<template>
    <site-img
        v-if="testimonials.length"
        class="md-testimonial broker-slider-classic"
        type="bgImg"
        :src="bgType == 'img' ? suitableImg : ''"
        :style="{ 'background-color': bgType == 'color' ? bgColor : null }"
        dir="width"
    >
        <module-box
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
            noPadding
        >
            <div class="title-wrap">
                <div :style="{ visibility: title ? 'unset' : 'hidden' }" v-html="formatFontSize(title, '--mg-title-size')" class="mg-title"></div>
                <Arrows
                    :show="showArrow"
                    :disabled="disabled"
                    @prev="prev"
                    @next="next"
                />
            </div>
            <Slider
                ref="sliders"
                @disabled="updateDisabled"
                @showarrow="updateShowArrow"
                theme="broker-slider-classic"
                :config="config"
                :list="testimonials"
                :pcHeight="265"
                :mobileHeight="265"
                :itemPcWidth="380"
                :itemMobileWidth="330"
            >
                <template v-slot="{ item }">
                    <!-- slide-item -->
                    <div class="item" @click="()=>toViewMore(item)">
                        <img v-if="item.rmaTrackPixelUrl" class="rma-pixel-img" :src="item.rmaTrackPixelUrl" loading="lazy" />
                        <div class="name">
                            <div class="info">
                                <i class="iconfont icon-people-solid"></i>
                                <span v-html="item.reviewerName"></span>
                            </div>
                            <only-client>
                                <span class="date">
                                    {{
                                        $ft.formatDate(
                                            item.reviewTime,
                                            'MMM dd yyyy'
                                        )
                                    }}
                                </span>
                            </only-client>
                        </div>
                        <div class="desc" v-html="item.reviewContent"></div>
                        <div class="start-box">
                            <ReviewScore
                                :onlyShowActiveScore="false"
                                :sourceType="item.sourceType"
                                :score="item.reviewRate"
                                :iconSize="16"
                                :iconSpace="5"
                            />
                            <ReviewSourceLogo
                                :sourceType="item.sourceType"
                                :height="20"
                            />
                        </div>
                    </div>
                </template>
            </Slider>
        </module-box>
    </site-img>
</template>

<script>
import common from '../index';
import Slider from '../_components/slider.vue';
import Arrows from '../_components/arrows.vue';
export default {
    mixins: [common],
    components: { Slider, Arrows },
    data: function() {
        return {
            disabled: { prev: false, next: false },
            showArrow: false
        };
    },
    computed: {
        config({ autoPlay, delayTime, speed }) {
            return {
                autoPlay: autoPlay,
                interval: delayTime,
                speed
            };
        }
    },
    methods: {
        prev() {
            this.$refs.sliders.prev();
        },
        next() {
            this.$refs.sliders.next();
        },
        updateDisabled(disabled) {
            this.disabled = disabled;
        },
        updateShowArrow(show) {
            this.showArrow = show;
        }
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.md-testimonial.broker-slider-classic {
    .rma-pixel-img{
      display: block;
        width: 0;
        height: 0;
    }
    .mg-container {
        width: calc(100% - 200px);
        @include media-1680 {
            width: 1180px !important;
        }
        @include media-600 {
            width: calc(100vw - 30px) !important;
        }
    }
    .title-wrap {
        display: flex;
        flex-direction: row;
        padding-bottom: 25px;
        justify-content: space-between;
        position: relative;
        @include media-600 {
            padding-bottom: 10px;
            // .mg-title {
            //     font-size: 16px;
            //     margin-bottom: 0;
            // }
        }
        .mg-title {
            width: 100%;
            padding-bottom: 0;
        }
        &.no-under-line {
            &::after {
                display: none;
            }
        }
        h2 {
            font-family: var(--mg-title-font);
            font-size: var(--mg-title-size);
            color: var(--mg-title-color);
            text-align: var(--mg-title-align);
            line-height: var(--mg-title-line-height);
            letter-spacing: var(--mg-title-letter-spacing);
            // white-space: nowrap;
            // overflow: hidden;
            // text-overflow: ellipsis;
            margin-right: 20px;
            flex: 1;
            @include media-600 {
                font-size: var(--mg-title-size-mobile) !important;
                line-height: var(--mg-title-line-height-mobile) !important;
                letter-spacing: var(--mg-title-letter-spacing-mobile);
            }
        }
    }
    .slide-item {
        .item {
            width: 100%;
            height: 100%;
            padding: 23px 20px 25px;
            background: #fff;
            border: 1px solid #dadada;
            border-radius: 5px;
            display: flex;
            flex-direction: column;
            cursor: pointer;
            &:hover {
                border-color: var(--color-theme);
                box-shadow: 0 4px 20px 0 rgba(0, 10, 30, 0.1);
            }
        }
        .name {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            .info {
                display: inline-flex;
                overflow: hidden;
                .iconfont {
                    color: #191919;
                    margin-right: 10px;
                    font-size: 20px;
                }
                span {
                    font: 18px var(--font-bold);
                    color: #191919;
                    line-height: 25px;
                    @include ellipsis();
                    flex: 1;
                }
            }
            .date {
                font-size: 12px;
                color: #a8a8a8;
                flex-shrink: 0;
            }
        }
        .desc {
            flex: 1;
            margin: 20px 0 30px;
            @include webkitBox(6);
            font-size: 14px;
            color: #191919;
            line-height: 19px;
        }
        .start-box {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
        }
    }
}
</style>
